// extracted by mini-css-extract-plugin
export default {"privacyContainer":"Privacy_privacyContainer__WSkKD","pageHeader":"Privacy_pageHeader__2ZTxs"};